import { render, staticRenderFns } from "./userNotes.vue?vue&type=template&id=58c197df&"
import script from "./userNotes.vue?vue&type=script&lang=js&"
export * from "./userNotes.vue?vue&type=script&lang=js&"
import style0 from "./userNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "userNotes.vue"
export default component.exports